exports.menuClick = function () {
    console.log("Hello");
    var nav = $(".nav-wrapper");
    var navHeight = nav.height();

    if (navHeight < 150) {
        $('.nav').css({
            'background-color' : 'white',
            'margin' : 'unset',
            'height' : '100%'
        });
        var currentHeight = $(window).height();
        TweenMax.to(nav, 1, {"height":currentHeight});
        $('html, body').css({
            'overflow' : 'hidden',
            'height' : '100%'
        });

        $("#a").addClass("rotate-down");
        $("#responsive-menu-icon").addClass("menu-up");
        $("#b").addClass("disappear");
        $("#c").addClass("rotate-up"); 
    } else {
        $('.nav').css({
            'height' : '100%',
            'background-color' : 'white'
        });
        TweenMax.to(nav, 1, {"height":72});
        $('html, body').css({
            'overflow' : 'auto',
            'height' : 'auto'
        });
        // if it's not less than full height, remove animation classes
        $("#a").removeClass("rotate-down");
        $("#responsive-menu-icon").removeClass("menu-up");
        $("#b").removeClass("disappear");
        $("#c").removeClass("rotate-up");
    };
    
}



// WEBPACK FOOTER //
// ./resources/js/components/responsive-menu.js